import Checkbox from './Checkbox'
import StyledCheckbox from './StyledCheckbox'

export default Checkbox
export { Checkbox, StyledCheckbox }
